import * as React from 'react';

import {ActionBox} from 'shells/action-box/action-box';
import {ErrorIcon, SuccessIcon} from 'shells/action-box/action-icons';
import {Button} from 'shells/button/button';

import type {EditionFragment as Edition} from 'nutshell-graphql-types';

import {appHistory} from '../../../../history';

import {isMissingComparisonSubscribeLink, isComparingContent} from '../a-b-testing/helpers';

import styles from './action-box.module.css';

type Props = {
    edition: Edition;
    onClickActionItem?: () => any;
};

export function UnsubscribeActionBox(props: Props) {
    return (
        <ActionBox
            title='Unsubscribe link'
            subtitle={getUnsubscribeText(props.edition)}
            icon={
                props.edition.hasUnsubscribeLink &&
                !isMissingComparisonSubscribeLink(props.edition) ? (
                    <SuccessIcon />
                ) : (
                    <ErrorIcon />
                )
            }
            actionElement={getUnsubscribeActionElement(props.edition, props.onClickActionItem)}
        />
    );
}

function getUnsubscribeText(edition: Edition) {
    if (isComparingContent(edition)) {
        if (edition.hasUnsubscribeLink && !isMissingComparisonSubscribeLink(edition)) {
            return 'Included';
        } else {
            return 'Each version needs an unsubscribe link';
        }
    }

    return edition.hasUnsubscribeLink ? 'Included' : 'All messages need an unsubscribe link';
}

function getUnsubscribeActionElement(edition: Edition, onClickAction?: () => any) {
    if ((edition && !edition.hasUnsubscribeLink) || isMissingComparisonSubscribeLink(edition)) {
        if (onClickAction) {
            return (
                <Button variant='text-primary' size='big' onClick={onClickAction}>
                    Learn how to add
                </Button>
            );
        }

        return (
            <div className={styles['button-container']}>
                <Button
                    variant='text-primary'
                    size='big'
                    onClick={() => {
                        NutClientConfig.shouldShowUnsubscribeModal = true;

                        appHistory.push(`${edition.htmlUrlPath}/editor`);
                    }}
                >
                    Learn how to add
                </Button>
            </div>
        );
    }
}
